(function($) {
$(function(){

    const template_url = $('#template_url').val();

    if ($('.js-load-more').length) {
        $('.js-load-more').on('click', function(e){
            e.preventDefault();

            // Alias the button element
            const self = $(this);

            // Get the JSON data from thr button itself
            const data_json = (self.attr('data-data')) ? self.attr('data-data') : '';
            const load_data = JSON.parse(data_json);

            // Add the post count to the JSON array we got amove
            var post_count = $('' + load_data.single_class).length;
            load_data.post_count = post_count;

            // Change the button text to the loading text
            self.addClass('loading');
            self.find('span').html(load_data.loading_text);

            $.ajax({
                method: "GET",
                url: template_url + "/load-more.php",
                data: load_data,
                complete: function(){
                    // console.log(this.url);
                }
            }).done(function(msg) {
                // console.log(msg);
                setTimeout(function(){
                    $('' + load_data.container_class).append(msg);
                    self.find('span').html(load_data.initial_text);
                    self.removeClass('loading');
                    if (load_data.total_posts == $('' + load_data.container_class + ' ' + load_data.single_class).length) {
                        $('.js-load-more').parent().remove();
                    }
                }, 500);
            });

        });
    }//if ($('.js-load-more').length)


    if ($('.js-faux-load-more').length) {
        $('.js-faux-load-more').on('click', function(e){
            e.preventDefault();
            const load_num = parseInt($(this).attr('data-load-items'));
            const total = parseInt($(this).attr('data-load-items-total'));
            const container_selector = $(this).attr('data-load-items-selector');
            const item_selector = $(this).attr('data-load-item-selector');

            $(container_selector + ' ' + item_selector + ':hidden').slice(0, load_num).fadeIn(300);

            if ($(container_selector + ' ' + item_selector + ':visible').length == total) {
                $('.load-more-wrapper').slideFadeOut(300);
            }


                
        });
    }//if ($('.js-faux-load-more').length)

    if ($('.js-gallery-load-more').length) {
        $('.js-gallery-load-more').on('click', function(e){
            e.preventDefault();
            var items = $('.other-images.hidden .photo-single-images-item');
            $('.grid').colcade('append', items);
            $('.other-images.hidden').remove();
            $('.js-gallery-load-more').remove();
        });
    }//if ($('.js-gallery-load-more').length)
    

});
})(jQuery);
